import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { Button, Form, Textarea, Select, DatePicker, ProTableOt, setParamsFilter, useProTableOt, Toaster, toast, Input } from "../../../ui/ot";
import { Label } from "../../../ui/label";
import { useBib } from "../../controllers/BibController";
import { useLibrary } from "../../controllers/LibraryController";
import { useItem } from "../../controllers/ItemController";
import { useHold } from "../../controllers/HoldController";
import dayjs from 'dayjs'

const CirculationPlace = () => {
    const { card, name } = useParams();
    const location = useLocation();
    const { title } = location.state || { title: undefined };
    const [form] = Form.useForm()
    const { BorrowerData } = location.state || { BorrowerData: undefined };
    const { biblionumber } = location.state || { biblionumber: undefined };

    const actionRef = useRef()

    const columns = [
        {
            title: '館藏編號',
            dataIndex: 'item_itemnumber',
            key: 'item_itemnumber',
        },
        {
            title: '館藏種類',
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: 'Barcode',
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: '館藏分館',
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: '館藏現在位置',
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: '索書號',
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: '副本編號',
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
    ]

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.key)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.key);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.key)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.key)
                selectRow = selectRow.filter(row => row.key !== record.key)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onChange: (record, selected) => {
            let select_temp = []
            let selectRow = []

            if (selected) {
                selected.map((value, key) => {
                    select_temp.push(value.key)
                    selectRow.push(value)
                })
            }
            else {
                selected.map((value, key) => {
                    const index = select_temp.indexOf(value.key);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
    };

    const onFormFinish = () => {
        postHoldData([{
            itemnumber: selectedRowsInfo?.find(_ => true)?.item_itemnumber,
            ...form.getValues(),
            expiration_date: form.getValues('expiration_date') ? dayjs(form.getValues('expiration_date'))?.format('YYYY-MM-DD') : undefined
        }])
    }

    const {
        BibData,
        getBibData,
    } = useBib({
        onBefore: () => { },
        onFinish: () => { },
    })

    const {
        LibraryData,
        getLibraryData
    } = useLibrary({
        onBefore: () => { },
        onLibrary: () => { },
    })
    const {
        ItemData,
        getItemData,
    } = useItem({})

    const {
        postHoldData
    } = useHold({
        onFinish: ({ axiosMode, status }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    toast.success("預約成功")
                }
            }
        }
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })

    useEffect(() => {
        form.setValue('borrowernumber', BorrowerData?.find(_ => true)?.borrowernumber)
        getBibData({
            biblionumber: biblionumber
        })
        getLibraryData()
    }, [])
    return (<>
        <Toaster richColors position="top-center" />
        <MainContainer>
            <WhiteBox>
                <Title>Hold details</Title>
                <div>Place a hold on :</div>
                <Label>{title}</Label>
                <Form
                    form={form}
                    onFinish={onFormFinish}
                >
                    <Form.Item
                        label={''}
                        name={'borrowernumber'}
                        hidden
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'讀者'}
                        name={'patron'}
                    >
                        <div>{BorrowerData?.find(_ => true)?.firstname} {BorrowerData?.find(_ => true)?.surname}({BorrowerData?.find(_ => true)?.cardnumber})</div>
                    </Form.Item>
                    <Form.Item
                        label={'預計優先'}
                        name={'estimatedPriority'}
                    >
                        <div>-</div>
                    </Form.Item>
                    <Form.Item
                        label={'備註'}
                        name={'notes'}
                    >
                        <Textarea rows={1} />
                    </Form.Item>
                    <Form.Item
                        label={'取書分館'}
                        name={'pickupLibrary'}
                    >
                        <Select options={LibraryData.map(item => (
                            {
                                label: item?.branchname,
                                value: item?.branchcode,
                            }
                        ))} />
                    </Form.Item>
                    <Form.Item
                        label={'保留日期'}
                        name={'expiration_date'}
                    >
                        <DatePicker />
                    </Form.Item>
                    <Button type="button" onClick={() => form.submit()}>
                        預約
                    </Button>
                </Form>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    rowKey={'item_itemnumber'}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            borrowernumber: biblionumber,
                            biblionumber: biblionumber
                            // "categorycode": "TEST",
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        return getItemData({
                            ...newParams
                        })
                    }}
                    rowSelection={{
                        selectedRowKeys: [],
                        type: "radio",
                        onSelectAll: rowSelection?.onSelectAll,
                        onSelect: rowSelection?.onSelect,
                        onChange: rowSelection?.onChange

                    }}
                />
            </WhiteBox >
        </MainContainer >
    </>
    );
};

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: start;
  gap: 0.5em;

  @media (max-width: 768px) {
    padding: 1em;
  }
`;
const WhiteBox = styled.div`
  background-color: #fff;
  padding: 1em;
  width: -webkit-fill-available;

  @media (max-width: 768px) {
    padding: 0.5em;
  }
`;
const Title = styled.div`
  text-align: left;
  width: 90%;
  font-size: 1.6em;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;
const ClearButton = styled.button`
  color: red;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
export default CirculationPlace;
